import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getBorrowAdvancePage = (projectCode, periodId, pageNum, pageSize) => {
  const url = `${API_ROOT_VER}/borrow-advance/main/${projectCode}/${periodId}?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchBorrowAdvanceList = (request, projectCode, periodId, pageNum, pageSize) => {
  const url = `${API_ROOT_VER}/borrow-advance/search-list/${projectCode}/${periodId}?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const getPaymentRecordAdvance = (projectCode, periodId, id) => {
  const url = `${API_ROOT_VER}/borrow-advance/${projectCode}/${periodId}?id=${id || ''}`
  return doGet(url)
}

export const savePaymentRecordAdvance = (request) => {
  const url = `${API_ROOT_VER}/borrow-advance`
  return doPostFiles(url, request)
}

export const deletePaymentRecordAdvance = (id) => {
  const url = `${API_ROOT_VER}/borrow-advance/${id}`
  return doDelete(url)
}

export const getBorrowAdvanceAttachments = (fileId) => {
  const url = `${API_ROOT_VER}/borrow-advance/attachments/${fileId}`
  return doDownload(url)
}

export const downloadBorrowAdvanceVoucher = (accountingBorrowId) => {
  const url = `${API_ROOT}/files/${accountingBorrowId}/borrow/voucher/form`
  return doDownload(url)
}

export const downloadBorrowAdvanceRecieptVoucher = (accountingBorrowId) => {
  const url = `${API_ROOT}/files/${accountingBorrowId}/borrow-reciept/voucher/form`
  return doDownload(url)
}

export const downloadBorrowAdvanceContractForm = (accountingBorrowId) => {
  const url = `${API_ROOT}/files/${accountingBorrowId}/borrow-advance/contract/form`
  return doDownload(url)
}

export const downloadBorrowAdvanceRetrunForm = (accountingBorrowId) => {
  const url = `${API_ROOT}/files/${accountingBorrowId}/borrow-advance/retrun/form`
  return doDownload(url)
}
